import apiExist from '@/api/exist'

const state = {
  data: null,
  isLoading: false,
  error: null
}

export const mutationsTypes = {
  getExistStart: '[exist] Get exist start',
  getExistSuccess: '[exist] Get exist success',
  getExistFailure: '[exist] Get exist failure'
}

export const actionsTypes = {
  getExist: '[exist] Get exist'
}

const mutations = {
  [mutationsTypes.getExistStart](state) {
    state.isLoading = true
    state.data = null
  },

  [mutationsTypes.getExistSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationsTypes.getExistFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionsTypes.getExist](context, params) {
    context.commit(mutationsTypes.getExistStart)

    return new Promise((resolve, reject) => {
      apiExist
        .getPhoneIsExist(params)
        .then(response => {
          context.commit(mutationsTypes.getExistSuccess, response)
          resolve(response)
        })
        .catch(error => {
          context.commit(mutationsTypes.getExistFailure)
          reject(error)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
